/**
 * used in
 * * ProductCreateContainer
 * * ProductEditContainer
 * * Product Components
 */
import "theme/colors.scss";

const productStyles = (theme) => ({
  formControl: {
    marginBottom: 4,
    marginTop: 8,
    width: "100%",
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
    borderRadius: "16px !important",
  },
  noLabel: {
    marginTop: 24,
  },
  multiSelect: {
    width: "100%",
  },
  checkbox: {
    width: 24,
    height: 24,
  },
  listItemText: {
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 8,
  },
  menuItem: {
    minHeight: 24,
  },
  priamrylistItemText: {
    fontSize: "0.9em",
  },
  containedPrimary: {
    color: "Red",
  },
});

export default productStyles;
